import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';

const getReadinessColor = (readinessIndex) => {
  if (readinessIndex < 0.33) return '#22C55E'; // Green
  if (readinessIndex < 0.66) return '#F59E0B'; // Amber
  return '#EF4444'; // Red
};

const getReadinessStatus = (readinessIndex) => {
  if (readinessIndex < 0.33) return 'Good';
  if (readinessIndex < 0.66) return 'Caution';
  return 'High Risk';
};

const ReadinessChart = ({ data, width = 678, height = 300 }) => {
  return (
    <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
      <LineChart 
        width={width} 
        height={height} 
        data={data}
        margin={{ top: 5, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
        <XAxis 
          dataKey="date" 
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          interval="preserveStartEnd"
        />
        <YAxis 
          domain={[0, 1]}
          ticks={[0, 0.5, 1]}
          stroke="#64748B"
          style={{ fontSize: '10px' }}
          label={{ value: 'Readiness', angle: -90, position: 'insideLeft', dx: 14, style: { fontSize: '11px', textAnchor: 'middle' } }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '10px', paddingTop: '10px' }}
          iconType="line"
        />
        <Line 
          type="monotone" 
          dataKey="readiness" 
          stroke="#10B981" 
          strokeWidth={2}
          name="Readiness Index"
          dot={(props) => {
            if (!props?.payload?.readiness && props?.payload?.readiness !== 0) return null;
            const color = getReadinessColor(props?.payload?.readiness);
            return (
              <circle 
                cx={props?.cx} 
                cy={props?.cy} 
                r={4} 
                fill={color}
                strokeWidth={2}
                stroke={color}
              />
            );
          }}
        />
      </LineChart>
      {/* Readiness Category Legend */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '8px', fontSize: '9px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#22C55E' }} />
          <span>Good (&lt;0.33)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#F59E0B' }} />
          <span>Caution (0.33-0.66)</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#EF4444' }} />
          <span>High Risk (≥0.66)</span>
        </div>
      </div>
    </div>
  );
};

export default ReadinessChart;